import React from 'react';
import SimpleReactLightbox from "simple-react-lightbox";
import Home from "./sites/Home";

class App extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }
    }

    render() {
        return (
            <SimpleReactLightbox>
                <div className="App">
                    <Home />
                </div>
            </SimpleReactLightbox>
        )
    }

}

export default App;
